import styled from "styled-components";

export const TitleMain = styled.h1`
  font-size: 5rem;
  font-weight: 700;
  text-align: center;
  color: var(--yellow);
`;